import { useMemo } from 'react'
import { useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import { entityTag } from './entityTags'
import { type CustomWorkflowLauncher, useCustomWorkflowLauncher } from './useCustomWorkflowLauncher'

export interface InsightsWorkflowScope {
  fromDate: string
  toDate: string
  userIds: string[]
}

export const useInsightsWorkflowLauncher = ({ fromDate, toDate, userIds }: InsightsWorkflowScope): CustomWorkflowLauncher => {
  const accountId = useAppSelector(selectAccountId)
  const userIdList = userIds.join(',')
  const context = useMemo(() => ({ insights_from_date: fromDate, insights_to_date: toDate, insights_user_ids: userIdList }), [fromDate, toDate, userIdList])

  return useCustomWorkflowLauncher({ accountId, scope: entityTag('insights'), context })
}
